module.exports = __webpack_public_path__ + "static/img/B4定向天线.af962ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/自动驾驶作业系统SAD200/B4定向天线.png
// module id = TufP
// module chunks = 0